import { COMPANY, NAV_ITEMS } from "@/lib/constants";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1128] text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="ra-grain absolute inset-0" />
      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 pb-16 border-b border-white/8">
          <div className="lg:col-span-5">
            <img
              src={COMPANY.logo}
              alt="Ramo Advisors LLC"
              className="h-14 w-auto mb-6"
            />
            <p className="font-body text-white/65 text-[15px] leading-relaxed max-w-md">
              Independent advisory services for real estate developers,
              investors, owners, and construction professionals — protecting
              capital and guiding execution from acquisition through close-out.
            </p>
            <div className="ra-eyebrow on-dark mt-8">
              <span className="ra-hairline" />
              <span>{COMPANY.tagline}</span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-heading text-[10px] tracking-[0.3em] text-white/45 uppercase mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <button
                    data-testid={`footer-nav-${item.id}`}
                    onClick={() => scrollToId(item.id)}
                    className="font-body text-white/75 hover:text-[#00A859] transition-colors text-[15px]"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-heading text-[10px] tracking-[0.3em] text-white/45 uppercase mb-5">
              Reach Us
            </div>
            <div className="space-y-3 font-body text-[15px]">
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="footer-phone"
                className="block text-white/80 hover:text-[#00A859] transition-colors"
              >
                {COMPANY.phone}
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="block text-white/80 hover:text-[#00A859] transition-colors break-all"
              >
                {COMPANY.email}
              </a>
              <div className="text-white/55 pt-2 leading-relaxed">
                New Jersey · New York
                <br />
                Remote Consulting Nationwide
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="font-body text-white/45 text-[13px]">
            © {new Date().getFullYear()} Ramo Advisors LLC. All rights reserved.
          </div>
          <div className="font-heading text-[10px] tracking-[0.3em] text-white/40 uppercase">
            Independent · Objective · Risk-First
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
